import React from "react";
import { useNavigate } from "react-router-dom";
import IntroTopSection from '../../../components/Introduction/IntroTopSection';
import IntroSubHeading from '../../../components/Introduction/IntroSubHeading';

function DirectionsPC() {
  const navigate = useNavigate();

  return (
    <div className="announcement-list-page intro-info-page">

      <IntroTopSection />

      {/* Main Content */}
      <main className="main-content">
        <IntroSubHeading heading="오시는 길" />

        <div className="directions-content-section">

          <div className="map-area">
            <img
              src="/images/map.png"
              alt="오시는 길 지도"
            />
          </div>

          <div className="directions-contact-banner">
            <div className="directions-contact-item">
              <div className="directions-contact-icon">
                <div className="directions-icon-circle">
                  <img
                    src="/images-directionpc/bee1147a2277046858d6d7638fff09a32f436a97.png"
                    alt="Location"
                    className="directions-icon-image"
                  />
                </div>
              </div>
              <div className="directions-contact-content">
                <span className="directions-contact-label">주소</span>
                <span className="directions-contact-value">인천광역시 강화군 송해면 강화대로 879-16 (하도리 208-7)</span>
              </div>
            </div>
            <div className="directions-contact-divider"></div>
            <div className="directions-contact-item">
              <div className="directions-contact-icon">
                <div className="directions-icon-circle">
                  <img
                    src="/images-directionpc/b07aa842eb4a297f74926e41b08daf1cea2c5a8c.png"
                    alt="Phone"
                    className="directions-icon-image"
                  />
                </div>
              </div>
              <div className="directions-contact-content">
                <span className="directions-contact-label">대표번호</span>
                <span className="directions-contact-value">1599-9442</span>
              </div>
            </div>
            <div className="directions-contact-divider"></div>
            <div className="directions-contact-item">
              <div className="directions-contact-icon">
                <div className="directions-icon-circle">
                  <img
                    src="/images-directionpc/0bf52fe92d12a7c0529c449579a3b56bdb46f6f8.png"
                    alt="Fax"
                    className="directions-icon-image"
                  />
                </div>
              </div>
              <div className="directions-contact-content">
                <span className="directions-contact-label">FAX</span>
                <span className="directions-contact-value">032-932-9213</span>
              </div>
            </div>
          </div>

          <div className="transport-guide">
            <h3 className="guide-title">교통편 안내</h3>
            <div className="transport-method">
              <div className="transport-icon-wrapper">
                <img
                  src="/images-directionpc/18_77.svg"
                  alt=""
                  className="icon-bg"
                />
                <img
                  src="/images-directionpc/5e78e536cfc8ed4345df21915681293c001eaaf5.png"
                  alt=""
                  className="icon-fg"
                />
              </div>
              <div className="transport-details">
                <h4>자가용을 이용하여 찾아오시는 길</h4>
                <ul>
                  <li>48번 국도 김포시 경유 <span className="arrow">▶</span> 강화대교</li>
                  <li>강화대교 <span className="arrow">▶</span> 강화읍 <span className="arrow">▶</span> 강화산성 서문 <span className="arrow">▶</span> 하점방향 직진</li>
                  <li>송해소방서 좌회전 <span className="arrow">▶</span> 강화파라다이스추모원</li>
                </ul>
              </div>
            </div>
            <div className="transport-method">
              <div className="transport-icon-wrapper">
                <img
                  src="/images-directionpc/18_80.svg"
                  alt=""
                  className="icon-bg"
                />
                <img
                  src="/images-directionpc/d53c01ea031256cccb146753f925b7c82320b0ab.png"
                  alt=""
                  className="icon-fg"
                />
              </div>
              <div className="transport-details">
                <h4>버스를 이용하여 찾아오시는 길</h4>

                <ul>
                  <li>서울(신촌, 합정, 송정역) <span className="arrow">▶</span> 강화 (3000번, 수시운행)</li>
                  <li>인천(터미널, 길병원, 인천의료원, 검단) <span className="arrow">▶</span> 강화 (800번 운행간격 1시간)</li>
                  <li>인천(부평, 계산동, 검단) <span className="arrow">▶</span> 강화 (90번, 수시운행)</li>
                  <li>강화터미널 <span className="arrow">▶</span> 파라다이스추모원(송해소방서) 하차 (23번, 25번, 27번, 30번, 32번, 33번, 34번, 35번, 수시운행)</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>

    </div>
  );
}

export default DirectionsPC; 